export const URL_API_BASE = process.env.REACT_APP_API_ENDPOINT;

export const URL_API_CARGA = `${URL_API_BASE}/cargarSoportes`;
export const URL_API_REPORTE = `${URL_API_BASE}/reporte`;
export const URL_API_CARGAS_DETALLES = `${URL_API_BASE}/cargas/@idCarga/archivos`;
export const URL_API_PRESTADORES = `${URL_API_BASE}/prestadores`;
export const URL_API_CONFIGURACION = `${URL_API_BASE}/configuracion`;
export const URL_API_LOGIN = `${URL_API_BASE}/login/authentication`;
